module.exports = __webpack_public_path__ + "static/media/individual-lives-icon.4168c1f4.svg";